import { Locations } from 'src/presentation/pages'

export const makeLocations = () => <Locations />
